import Swiper from 'swiper/dist/js/swiper.min';

jQuery(document).ready(function ($) {

    if ($(window).width() > 767) {

        let cardSlider = new Swiper('.card-slider ', {
            loop: true,
            slidesPerView: 3,
            spaceBetween: 56,
            centeredSlides: true,
            direction: 'horizontal',
            freeMode: false,
            autoplay: {
                delay: 0,
                disableOnInteraction: true
            },
            speed: 6000,
            grabCursor: true,
            breakpoints: {
                560: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 56
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 56
                }
            }
        });
    }

    let logoSlider = new Swiper('.logo-slider ', {
        loop: true,
        slidesPerView: 7,
        spaceBetween: 100,
        centeredSlides: true,
        direction: 'horizontal',
        autoplay: true,
        breakpoints: {
            560: {
                slidesPerView: 3,
                spaceBetween: 56
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 56
            },
            992: {
                slidesPerView: 7,
                spaceBetween: 56
            }
        }
    });

    if ($(window).width() > 767) {

        let historySlider = new Swiper('.history-slider ', {
            loop: false,
            slidesPerView: 3,
            spaceBetween: 40,
            navigation: {
                nextEl: ".arrow--next",
                prevEl: ".arrow--prev",
            },
        });
    }
});